import React from "react";
import {
  SiVisualstudiocode,
  SiGit,
  SiGithub,
  SiVercel,
  SiPostman,
  SiFigma,
} from "react-icons/si";

const toolList = [
  { Icon: SiVisualstudiocode, name: "VS Code", color: "#007acc" },
  { Icon: SiGit,              name: "Git",     color: "#f05032" },
  { Icon: SiGithub,           name: "GitHub",  color: "#d0d0d0" },
  { Icon: SiVercel,           name: "Vercel",  color: "#d0d0d0" },
  { Icon: SiPostman,          name: "Postman", color: "#ff6c37" },
  { Icon: SiFigma,            name: "Figma",   color: "#f24e1e" },
];

function Toolstack() {
  return (
    <div className="tech-icon-grid">
      {toolList.map(({ Icon, name, color }) => (
        <div
          key={name}
          className="tech-icon-item"
          style={{ "--brand-color": color }}
        >
          <Icon />
          <span className="tech-icon-label">{name}</span>
        </div>
      ))}
    </div>
  );
}

export default Toolstack;
